<template>
    <div class="tab-header">
        <md-tabs md-alignment="left" @md-changed="onTabChange($event)" :md-active-tab="activeTab" ref="tabs"
            class="md-tab-content-page">
            <md-tab to="/users/UKL" v-if="hasAccess('PRIVILEGE_USER_LIST_KL')" id="tab-client-users"
                    :md-label="$t('views.admin.dashboard.users.label')">
                <UserList v-if="activeTab === 'tab-client-users'" what-user-list="users" :filter-value="filterValue" :show-inactive-users="showInactiveUsers" />
            </md-tab>
            <md-tab to="/users/UPM" v-if="hasAccess('PRIVILEGE_USER_LIST_PM')" id="tab-polsat-users"
                    :md-label="$t('views.admin.dashboard.polsat.label')">
                <UserList v-if="activeTab === 'tab-polsat-users'" what-user-list="polsat" :filter-value="filterValue" :show-inactive-users="showInactiveUsers" />
            </md-tab>
            <md-tab to="/users/USA" v-if="hasAccess('PRIVILEGE_USER_LIST_SA')" id="tab-admins"
                    :md-label="$t('views.admin.dashboard.admins.label')">
                <UserList v-if="activeTab === 'tab-admins'" what-user-list="admins" :filter-value="filterValue" :show-inactive-users="showInactiveUsers" />
            </md-tab>
            <md-tab to="/users/AD" v-if="hasAccess('PRIVILEGE_USER_LIST_AD')" id="tab-users-ad"
                    :md-label="$t('views.admin.dashboard.ad.label')">
                <ADUserList v-if="activeTab === 'tab-users-ad'" @closeSearcher="searchExpand = $event" :filter-value="filterValue" />
            </md-tab>
        </md-tabs>
      <div class="showInactiveUsersBox">
        <md-checkbox v-model="showInactiveUsers" @change="showUsers()" />
        <div class="showInactiveUsersLabel">
          Pokazuj nieaktywnych
        </div>
      </div>
        <div class="md-flex-right-align">
        <div class="md-search-btn" v-if="!searchExpand" @click="searchExpand = !searchExpand">
            <md-icon>search</md-icon>
        </div>
        <adsign-filter v-if="searchExpand" v-model="filterValue" :filter-data-model="filterDataModel" class=""
            @search="searchTemplate()" :is-ad-user="activeTab === 'tab-users-ad' ? true : false" :show-date-picker="activeTab === 'tab-users-ad' ? false : true" />
        <navigation-tab-buttons />
        </div>
    </div>
</template>

<script>
    import ADUserList from "./ActiveDirectoryUserList";
    import UserList from "@/views/admin/dashboard/users/UserList";
    import {mapGetters} from "vuex";
    import NavigationTabButtons from "@/components/NavigationTabButtons";
    import AdsignFilter from '@/components/AdsignFilter';
    import {FilterType} from '@/mixins/filterType';
    import store from "@/store";

    export default {
        name: "Users",
        showInactiveUsers: false,
        components: {ADUserList, UserList, NavigationTabButtons, AdsignFilter},
        computed: {
            ...mapGetters('auth', ['hasAccess', 'userId']),
            ...mapGetters("misc", ["searcherFilterData"]),

        },
        data: () => {
            return {
                totalPagesAD: null,
                activeTab: undefined,
                snackbar: {
                    showSnackbar: false,
                    message: ''
                },
                searchExpand: false,
                showInactiveUsers: false,
                filterValue: null,
                isSearching: false,
                filterDataModel: [
                {id: 'firstName', type: FilterType.String},
                {id: 'lastName', type: FilterType.String},
                {id: 'email', type: FilterType.String},
                {id: 'validFrom', type: FilterType.Date},
                {id: 'validTo', type: FilterType.Date},
                ],
            }
        },
        mounted: function () {
            const tabs = Object.entries(this.$refs.tabs.MdTabs.items);
            const currentTab = tabs
                .map(item => ({
                    id: item[0],
                    ...item[1]
                }))
                .find(tab => this.$route.path.endsWith(tab.props.to));

            if (currentTab) {
                this.activeTab = currentTab.id;
            }

            
            this.$watch(() => this.searcherFilterData, (result) => {
                this.filterValue = result.filter
                this.searchExpand = result.searchExpand
            })
        },
        methods: {
            onTabChange(tabId) {
                if (tabId) {
                    this.activeTab = tabId;
                    store.commit('misc/SEARCHER_DATA', {
                        filter: '',
                        inputData: '',
                        searchExpand: false
                    })
                }
            },
            searchTemplate() {
                return (this.filterValue);
            },
            showUsers(){
                this.$forceUpdate();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .tab-header {
        display: flex;
    }
    .showInactiveUsersBox{
      margin: 0 10px;
      padding: 0 10px;
      display: flex;
      justify-content:center;
      align-items: center;
      background-color:white;
      height: 48px;
    }
    .showInactiveUsersLabel{
      font-size: 12px;
    }
</style>
